import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  toolbar: theme.mixins.toolbar,
  content: {
    // flexGrow: 1,
    marginTop: '70px',
    padding: theme.spacing(3),
    width: '80%',
    margin: 'auto',
    minHeight: '500px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  root: {
    flexGrow: 1,
  },
}));